import TopNavigationLayout from '../../../../layouts/TopNavigationLayout';
import Payment from './Payment';
export default TopNavigationLayout(Payment);
